import * as React from 'react';
import { SVGProps } from 'react';
const SvgInfo = ({
  width = 24,
  height = 24,
  ...props
}: SVGProps<SVGSVGElement>) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="#000"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2Zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8Z"
      fill="current"
    />
    <path d="M11 11h2v6h-2v-6Zm0-4h2v2h-2V7Z" fill="current" />
  </svg>
);
export default SvgInfo;
